module.exports = __webpack_public_path__ + "static/media/age_rating_0.29e999eb.svg";